import { createFileRoute, redirect } from '@tanstack/react-router';

import { homeRedirectTarget } from '../features/permissions/route-guard';

// `/` has no page of its own: it lands the user on their first readable
// section (the same rung order as a denied deep link), or `/no-access` when
// nothing is readable — so it never strands someone on an empty shell.
export const Route = createFileRoute('/')({
  beforeLoad: ({ context: { queryClient, auth } }) => {
    throw redirect({ href: homeRedirectTarget(queryClient, auth.partner), replace: true });
  },
});
